export const ALL_OPERATIONS = 'all-operations';
export const ALL_OPERATIONS_TITLE = 'All Operations';

export const ALL_OPERATIONS_OPTION_OBJECT = {
  operationId: ALL_OPERATIONS,
  operationName: ALL_OPERATIONS_TITLE,
  farms: [],
  operationOwnerId: -1
};

export enum OperationStorage {
  OperationSelected = 'operation-selected',
  OperationsSelected = 'operations-selected',
}